module.exports = __webpack_public_path__ + "img/md.39571e7b.jpg";